import m from './module';
import validationTypeMap from '../model/validationTypes/map';
import ValidationType from '../model/ValidationType';

const path = '/recap_validation_type';
const type = 'ValidationType';

class ValidationTypeService {
  constructor($q, APIService, DataSyncService) {
    "ngInject";
    this.APIService = APIService;
    this.DataSyncService = DataSyncService;
    this.$q = $q;

    this._mapByKey = {};
  }

  create(data) {
    data = data || {};
    const cls = data.key && this._getClassForKey(data.key) || ValidationType;
    const type = new cls(data);
    return this.$q.when(type);
  }

  getAll(config = null) {
    return this.DataSyncService.getMultipleObjects(type, path, data => this.create(data), config);
  }

  getByKey(key) {
    if (!(key in this._mapByKey)) {
      this._mapByKey[key] = this.getAll()
        .then(all => all.find(obj => obj.key === key));
    }
    // TODO: Find a way to move this promise map into DataSyncService so it can be cleared during refresh
    return this._mapByKey[key];
  }
  enabledKeysForType(type) {
    if ([
      'FIELD_LABEL',
      'FIELD_SUBSECTION',
      'FIELD_DISPLAY_TEXT',
      'FIELD_DISPLAY_IMAGE',
      'FIELD_HYPERLINK',
    ].includes(type)) {
      // End early if it's a field that doesn't take input
      return [];
    }

    // Add relevant validations per field type
    const validationTypes = [];
    validationTypes.push('responseRequired');
    if ([
      'FIELD_TEXT',
      'FIELD_TEXTAREA',
    ].includes(type)) {
      validationTypes.push('minTextLength');
    }

    if ([
      'FIELD_TEXT',
      'FIELD_TEXTAREA',
    ].includes(type)) {
      validationTypes.push('maxTextLength');
    }

    if ([
      'FIELD_TEXT',
    ].includes(type)) {
      validationTypes.push('validEmailAddress');
    }

    if ([
      'FIELD_PHONENUMBER',
    ].includes(type)) {
      validationTypes.push('validPhoneNumber');
    }

    if ([
      'FIELD_INTEGER',
      'FIELD_FLOAT1',
      'FIELD_FLOAT2',
      'FIELD_FORMULA',
      'FIELD_MONEY',
      'FIELD_DURATION',
    ].includes(type)) {
      validationTypes.push('gtValue');
    }

    if ([
      'FIELD_INTEGER',
      'FIELD_FLOAT1',
      'FIELD_FLOAT2',
      'FIELD_FORMULA',
      'FIELD_MONEY',
      'FIELD_DURATION',
    ].includes(type)) {
      validationTypes.push('gteValue');
    }

    if ([
      'FIELD_INTEGER',
      'FIELD_FLOAT1',
      'FIELD_FLOAT2',
      'FIELD_FORMULA',
      'FIELD_MONEY',
      'FIELD_DURATION',
    ].includes(type)) {
      validationTypes.push('ltValue');
    }

    if ([
      'FIELD_INTEGER',
      'FIELD_FLOAT1',
      'FIELD_FLOAT2',
      'FIELD_FORMULA',
      'FIELD_MONEY',
      'FIELD_DURATION',
    ].includes(type)) {
      validationTypes.push('lteValue');
    }

    if ([
      'FIELD_TEXT',
      'FIELD_INTEGER',
      'FIELD_FLOAT1',
      'FIELD_FLOAT2',
      'FIELD_FORMULA',
      'FIELD_MONEY',
      'FIELD_TEXTAREA',
      'FIELD_DURATION',
    ].includes(type)) {
      validationTypes.push('equalsValue');
    }

    if ([
      'FIELD_TEXT',
      'FIELD_TEXTAREA',
    ].includes(type)) {
      validationTypes.push('containsValueCaseSensitive');
      validationTypes.push('containsValueCaseInsensitive');
      validationTypes.push('doesNotContainValueCaseInsensitive');
      validationTypes.push('doesNotContainValueCaseSensitive');
    }

    if ([
      'FIELD_INTEGER',
      'FIELD_FLOAT1',
      'FIELD_FLOAT2',
      'FIELD_FORMULA',
      'FIELD_MONEY',
      'FIELD_DURATION',
    ].includes(type)) {
      validationTypes.push('gtField');
    }

    if ([
      'FIELD_INTEGER',
      'FIELD_FLOAT1',
      'FIELD_FLOAT2',
      'FIELD_FORMULA',
      'FIELD_MONEY',
      'FIELD_DURATION',
    ].includes(type)) {
      validationTypes.push('gteField');
    }

    if ([
      'FIELD_INTEGER',
      'FIELD_FLOAT1',
      'FIELD_FLOAT2',
      'FIELD_FORMULA',
      'FIELD_MONEY',
      'FIELD_DURATION',
    ].includes(type)) {
      validationTypes.push('ltField');
    }

    if ([
      'FIELD_INTEGER',
      'FIELD_FLOAT1',
      'FIELD_FLOAT2',
      'FIELD_FORMULA',
      'FIELD_MONEY',
      'FIELD_DURATION',
    ].includes(type)) {
      validationTypes.push('lteField');
    }

    if ([
      'FIELD_TEXT',
      'FIELD_INTEGER',
      'FIELD_FLOAT1',
      'FIELD_FLOAT2',
      'FIELD_FORMULA',
      'FIELD_MONEY',
      'FIELD_TEXTAREA',
      'FIELD_DURATION',
    ].includes(type)) {
      validationTypes.push('equalsField');
    }

    if ([
      'FIELD_DATE',
    ].includes(type)) {
      validationTypes.push('equalsDate');
      validationTypes.push('equalsDateField');
      validationTypes.push('afterDateIn');
      validationTypes.push('afterDateEx');
      validationTypes.push('beforeDateIn');
      validationTypes.push('beforeDateEx');
      validationTypes.push('afterDateFieldIn');
      validationTypes.push('afterDateFieldEx');
      validationTypes.push('beforeDateFieldIn');
      validationTypes.push('beforeDateFieldEx');
    }

    if ([
      'FIELD_DATETIME',
    ].includes(type)) {
      validationTypes.push('equalsDateTime');
      validationTypes.push('equalsDateTimeField');
      validationTypes.push('afterDateTimeIn');
      validationTypes.push('afterDateTimeEx');
      validationTypes.push('beforeDateTimeIn');
      validationTypes.push('beforeDateTimeEx');
      validationTypes.push('afterDateTimeFieldIn');
      validationTypes.push('afterDateTimeFieldEx');
      validationTypes.push('beforeDateTimeFieldIn');
      validationTypes.push('beforeDateTimeFieldEx');
    }

    if ([
      'FIELD_TIME',
    ].includes(type)) {
      validationTypes.push('equalsTime');
      validationTypes.push('equalsTimeField');
      validationTypes.push('afterTimeIn');
      validationTypes.push('afterTimeEx');
      validationTypes.push('beforeTimeIn');
      validationTypes.push('beforeTimeEx');
      validationTypes.push('afterTimeFieldIn');
      validationTypes.push('afterTimeFieldEx');
      validationTypes.push('beforeTimeFieldIn');
      validationTypes.push('beforeTimeFieldEx');

    }
    return validationTypes;
  }

  _getClassForKey(key) {
    return validationTypeMap[key];
  }
}



export default ValidationTypeService;

m.service('ValidationTypeService', ValidationTypeService);
